module.exports = __webpack_public_path__ + "img/brain.013f24cc.svg";